import getEnvVar from "../utils/getEnvVar";
import { ServiceConfig } from "../types/serviceConfig";

/**
 * Fetch environment variables with sensible defaults.
 */
const API_HOST_URL = getEnvVar(
	"REACT_APP_API_HOST_URL",
	"http://127.0.0.1:7007"
);
const API_PREFIX = getEnvVar("REACT_APP_API_PREFIX", "/api/v1");
const USE_MOCK_API = getEnvVar("REACT_APP_USE_MOCK_API", "1") === "1";

/**
 * Construct the service configuration object using the defined types.
 */
export const serviceConfig: ServiceConfig = {
	api: {
		hostUrl: API_HOST_URL,
		prefix: API_PREFIX,
		baseUrl: `${API_HOST_URL}${API_PREFIX}`,
		useMock: USE_MOCK_API,
	},
	routes: {
		login: getEnvVar("REACT_APP_API_ADMIN_LOGIN", "/admin/login"),
		admins: getEnvVar("REACT_APP_API_ADMINS", "/admins"),
		adminSearch: getEnvVar("REACT_APP_API_ADMIN_SEARCH", "/admins/search"),
		categories: getEnvVar("REACT_APP_API_CATEGORIES", "/categories"),
		subcategories: getEnvVar(
			"REACT_APP_API_SUBCATEGORIES",
			"/categories/subcategories"
		),
		requests: getEnvVar("REACT_APP_API_REQUESTS", "/requests"),
		requestSearch: getEnvVar(
			"REACT_APP_API_REQUEST_SEARCH",
			"/requests/search"
		),
		requestFilter: getEnvVar(
			"REACT_APP_API_REQUEST_FILTER",
			"/requests/filter"
		),
		units: getEnvVar("REACT_APP_API_UNITS", "/units"),
		unitSearch: getEnvVar("REACT_APP_API_UNIT_SEARCH", "/units/search"),
		users: getEnvVar("REACT_APP_API_USERS", "/users"),
		userSearch: getEnvVar("REACT_APP_API_USER_SEARCH", "/users/search"),
		userHistory: getEnvVar("REACT_APP_API_USER_HISTORY", "/users/history"),
		logs: getEnvVar("REACT_APP_API_LOGS", "/logs"),
		logSearch: getEnvVar("REACT_APP_API_LOG_SEARCH", "/logs/search"),
		logFilter: getEnvVar("REACT_APP_API_LOG_FILTER", "/logs/filter"),
		logsAdmin: getEnvVar("REACT_APP_API_LOGS_ADMIN", "/logs/admin"),
		logsUser: getEnvVar("REACT_APP_API_LOGS_USER", "/logs/user"),
	},
	headers: {
		contentType: getEnvVar(
			"REACT_APP_API_CONTENT_TYPE",
			"application/json; charset=utf-8"
		),
		accept: getEnvVar(
			"REACT_APP_API_ACCEPT",
			"application/json; charset=utf-8"
		),
	},
};

export default serviceConfig;
